import { CardConfig } from '@affinis/smartus-components/lib/card/card.component.types';
import { Tab } from '@affinis/smartus-components/lib/tabs/tabs.components.types';
import { ChangeDetectorRef, Component, isDevMode, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FmConfigurationRow,
  FmIncident,
  FmIncidentServiceLine,
  FmPurchaseOrder,
  FmQuotation,
  FmQuotationLine,
  FmQuotationRequestLine,
  FmTask,
  IncidentClient,
  IncidentFieldMapping,
  OptionSetClient,
  OrganisationClient,
  ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping,
  SendIncidentCommunicationRequest,
  SysEnum,
  TaskClient,
  TaskStatus,
  UpdateIncidentDTO,
  UpdateTaskDTO,
} from '@core/api';
import { BreadcrumbService } from '@core/services/breadcrumb-service/BreadcrumbService';
import { IncidentClass } from '@core/services/ticket-list-desk-service/incidentClass';
import { IbpdiHelperService } from '@core/services/translate-service/ibpdi-helper.service';
import { TranslateDataService } from '@core/services/translate-service/translate-data.service';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { IDetailFields } from '@shared/components/details/detail-fields/models/detail-fields.model';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { DocumentVisibility } from '@shared/types/document.types';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { finalize, first, map, switchMap, take } from 'rxjs/operators';
import { SERVICE_LINE_COLUMNS } from '@shared/constants/grid-columns.constants';
import { formatPrice } from '@shared/utils/price-formatter';
import { getServiceRegistrationDocumentsByQuotationLineId } from '@shared/utils/service-registration.utils';
import { from } from 'rxjs';
import { TaskExcelExportService } from '@core/services/excel-export-service/task-excel-export.service';
import { TaskEquipmentService } from '../../../../../mandants/telekom/features/tasks/task-details/services/task-equipment.service';
import { TaskSubject } from '@shared/constants/taskSubjects.constants';
import { QuotationTypes } from '@shared/constants/quotation-types.constants';
import { PreviousOffersDialogComponent } from '../../../../../mandants/telekom/features/tasks/previous-offers-dialog/previous-offers-dialog.component';
import {
  buildTaskTooltipKey,
  getIncidentQuotationsFromTask,
  getLatestAcceptedAddendumQuotationFromTask,
  getLatestAddendumQuotationFromTask,
  getLatestAddendumQuotationLinesFromTask,
  getLatestAddendumStatusReasonFromTask,
  isAcceptedAddendumStatusReasonValue,
  isAddendumQuotationByType,
  translateIfTooltipKey,
} from '@shared/utils/task-offer.utils';

interface IContactForm {
  subject: string;
  content: string;
}

@Component({
  selector: 'app-task-details-view',
  templateUrl: 'task-details-view.component.html',
  styleUrls: ['./task-details-view.component.scss'],
  standalone: false,
  providers: [TaskEquipmentService],
})
export class TaskDetailsViewComponent implements OnInit {
  public title = this.translateService.instant('taskmodule.task.view.title');

  public isLoading = false;

  public masterRequired = true;

  isDevMode = isDevMode();

  form = new FormGroup({});
  formModel: any = {};
  formFields: FormlyFieldConfig[];

  formContactUs = new FormGroup({});
  formFieldsContactUs: Array<FormlyFieldConfig> = [];
  formModelContactUs = {} as IContactForm;

  entity: ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping;

  task?: FmTask;

  dataContactAddress: FmIncident;

  extension?: IncidentFieldMapping[];

  saveButtonLabel: string;

  private updateIncidentFieldGroupName = 'updateIncidentFieldsFormlyGroup';
  private readonly addendumOfferTypeId = 'affinis_offertype-100000001';
  private organisationMap = new Map<string, any>();
  private isPreviousOffersDialogOpening = false;
  private previousOffersDialogRef: MatDialogRef<PreviousOffersDialogComponent> | null =
    null;

  cardFields: CardConfig;

  cardContact: CardConfig;

  cardContactUs: CardConfig = {
    footer: {
      button1: {
        label: this.translateService.instant('form.submit'),
        disabled: false,
        onClick: () => {
          this.validateForm();
        },
      },
    },
  };

  tabs: Tab[] = [
    {
      label: this.translateService.instant(
        'taskmodule.task.update.update_incident_fields'
      ),
      id: 'editIncidentFields',
      onClick: (id: string) => this.onTabClick(id),
    },
    {
      label: this.translateService.instant('taskmodule.shared.label__contact'),
      id: 'contact',
      onClick: (id: string) => this.onTabClick(id),
    },
  ];

  activeTab = this.tabs[0].id;

  isWideLayout = false;
  private readonly wideLayoutStorageKey = 'task-details-wide-layout';
  buttonMaxWidthTitle = this.translateService.instant(
    'taskmodule.task.button.tooltip.max_width'
  );

  onTabClick(value: string) {
    this.activeTab = value;
  }

  toggleWideLayout() {
    this.setWideLayout(!this.isWideLayout);
  }

  private setWideLayout(isWideLayout: boolean) {
    this.isWideLayout = isWideLayout;
    this.buttonMaxWidthTitle = this.translateService.instant(
      isWideLayout
        ? 'taskmodule.task.button.tooltip.reset'
        : 'taskmodule.task.button.tooltip.max_width'
    );

    try {
      sessionStorage.setItem(
        this.wideLayoutStorageKey,
        JSON.stringify(isWideLayout)
      );
    } catch {
      return;
    }
  }

  private restoreWideLayoutPreference() {
    try {
      const storedValue = sessionStorage.getItem(this.wideLayoutStorageKey);

      if (storedValue !== null) {
        this.setWideLayout(JSON.parse(storedValue) === true);
        return;
      }
    } catch {
      return;
    }

    this.setWideLayout(false);
  }

  locations:
    | FmIncidentServiceLine[]
    | FmQuotationRequestLine[]
    | FmQuotationLine[] = [];
  editedLocations: FmQuotationLine[] = [];
  serviceRegistrationLocations: any[] = [];
  isDummyFrameworkContract = false;

  serviceLineColumns = SERVICE_LINE_COLUMNS;

  incidentInformations: FormlyFieldConfig[] = [
    {
      wrappers: ['card'],
      fieldGroup: [
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.ticketNumber',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__ticketNumber'),
                readOnly: true,
              },
            },
            {
              key: 'incident.requestType',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentType'),
                readOnly: true,
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentTitle'),
                readOnly: true,
              },
            },
            {
              key: 'incident.incidentClass.incidentClass',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentClass'),
                readOnly: true,
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.archObjId',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentFunctionalLocation'),
                readOnly: true,
              },
            },
            {
              key: 'incident.dtagResponsibility',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentDtagResponsibility'),
                readOnly: true,
              },
            },
          ],
        },
      ],
    },
  ];

  taskInformations: FormlyFieldConfig[] = [
    {
      key: 'subject',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__subject'),
        readOnly: true,
      },
    },
    {
      key: 'description',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__taskDescription'),
        readOnly: true,
      },
    },
    {
      key: 'dueDate',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__dueDate'),
        readOnly: true,
        valueFormatter: dueDate => {
          if (!dueDate) {
            return '--';
          }
          const now = moment(new Date());
          let r = moment(dueDate)
            .locale(this.translateService.instant('locale.locale'))
            .format(
              this.translateService.instant('locale.moment__date_format')
            );
          r +=
            moment(dueDate).diff(now, 'days') < 0
              ? ` <span style="color:red"> ${this.translate(
                  'info__overdue'
                )} <span class="material-icons" style="vertical-align: bottom">warning_amber</span> </span>`
              : '';
          return r;
        },
      },
    },
    {
      wrappers: ['form-field', 'count-chars'],
      key: 'result',
      type: 'textarea',
      props: {
        label: this.translate('label__result'),
        visibleInConfirm: true,
        required: false,
        disabled: true,
        autosize: true,
        autosizeMinRows: 4,
      },
    },
    {
      key: 'cancelStatus',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__cancelStatus'),
        readOnly: true,
      },
    },
    {
      key: 'status',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__actualStatus'),
        readOnly: true,
      },
    },
  ];

  incidentOPLExtInformations: FormlyFieldConfig[] = [
    {
      wrappers: ['card'],
      fieldGroup: [
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.ticketNumber',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__ticketNumber'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.ticketNumber'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.requestType',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentType'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.incidentType'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentTitle'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.incidentTitle'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.description',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incident_description'),
                readOnly: true,
              },
              expressions: {
                'props.tooltip': () =>
                  this.translateIfKey(
                    this.getTaskTooltipKey('incidentDescription')
                  ),
              },
            },
            {
              key: 'incident.incidentClass.incidentClass',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__incidentClass'),
                readOnly: true,
              },
              expressions: {
                'props.tooltip': () =>
                  this.translateIfKey(this.getTaskTooltipKey('incidentClass')),
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'incident.product.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__productName'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.productName'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.product.description',
              type: 'input',
              wrappers: ['readOnly'],
              hideExpression: () => this.isTask2_3_7_11,
              props: {
                label: this.translate('label__productDescription'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.productDescription'
                ),
                readOnly: true,
              },
            },
          ],
        },
        {
          type: 'flex-layout',
          fieldGroup: [
            {
              key: 'reporterFullName',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__reporter'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.reporter'
                ),
                readOnly: true,
              },
              expressions: {
                'model.reporterFullName': field => {
                  const firstname =
                    field.model?.incident?.fmServiceRequestExternal?.creator
                      ?.firstname || '';
                  const lastname =
                    field.model?.incident?.fmServiceRequestExternal?.creator
                      ?.lastname || '';
                  return `${firstname} ${lastname}`.trim();
                },
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.purchasingInformation',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__purchasingInformation'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.purchasingInformation'
                ),
                readOnly: true,
              },
              hideExpression: () =>
                !this.isTask2EvaluateOffersAndCreateSuppliers,
            },
            {
              key: 'incident.fmServiceRequestExternal.serviceProvider.name',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__supplier'),
                readOnly: true,
              },
              expressions: {
                'model.incident.fmServiceRequestExternal.serviceProvider.name':
                  field => {
                    const sp =
                      field.model?.incident?.fmServiceRequestExternal
                        ?.serviceProvider;
                    const org = this.organisationMap.get(sp?.organisationId);
                    if (!org) return sp?.name || '';
                    return [
                      org.name,
                      org.id,
                      org.address?.city,
                      org.address?.postalCode,
                      org.address?.streetName,
                    ]
                      .filter(Boolean)
                      .join(', ');
                  },
                'props.tooltip': () =>
                  this.translateIfKey(this.getTaskTooltipKey('supplier')),
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.deliveryTargetDate',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__deliveryTargetDate'),
                readOnly: true,
                valueFormatter: (date: string) => {
                  if (!date) {
                    return '--';
                  }
                  return this.formatDateString(new Date(date));
                },
              },
              expressions: {
                'props.tooltip': () =>
                  this.translateIfKey(
                    this.getTaskTooltipKey('deliveryTargetDate')
                  ),
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.priority.defaultName',
              type: 'input',
              wrappers: ['readOnly'],
              props: {
                label: this.translate('label__priority'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.priority'
                ),
                readOnly: true,
              },
            },
            {
              key: 'formly-notification-task11',
              type: 'formly-notification',
              hideExpression: () => !this.isTask11SubmitInvoiceToScanCenter,
              props: {
                heading: this.translateService.instant(
                  'taskmodule.task.offer.notification_task_11'
                ),
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.offerComment',
              type: 'input',
              wrappers: ['readOnly'],
              hideExpression: () =>
                this.isTask2EvaluateOffersAndCreateSuppliers ||
                this.isTask3EvaluateOfferInquiry ||
                this.isTask7ExecuteOptionalService ||
                this.isTask11SubmitInvoiceToScanCenter,
              props: {
                label: this.translate('label__offerComment'),
                tooltip: this.translateService.instant(
                  'taskmodule.task.offer.tooltip.offerComment'
                ),
                readOnly: true,
              },
            },
            {
              key: 'incident.fmServiceRequestExternal.auxilaryAccountAssignment.value',
              type: 'input',
              wrappers: ['readOnly'],
              hideExpression: () =>
                this.isTask2EvaluateOffersAndCreateSuppliers ||
                this.isTask3EvaluateOfferInquiry ||
                this.isTask7ExecuteOptionalService ||
                this.isTask11SubmitInvoiceToScanCenter,
              props: {
                label: this.translate('label__auxilaryAccountAssignment'),
                readOnly: true,
              },
            },
          ],
        },
      ],
    },
  ];

  taskOPLExtInformations: FormlyFieldConfig[] = [
    {
      key: 'subject',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__subject'),
        tooltip: this.translateService.instant(
          'taskmodule.task.offer.tooltip.subject'
        ),
        readOnly: true,
      },
    },
    {
      wrappers: ['form-field', 'count-chars'],
      key: 'result',
      type: 'textarea',
      props: {
        label: this.translate('label__result'),
        visibleInConfirm: true,
        required: false,
        disabled: true,
        autosize: true,
        autosizeMinRows: 4,
      },
    },
    {
      key: 'validUntil',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: 'Angebotsbindefrist',
        readOnly: true,
        valueFormatter: (value: any) => {
          if (!value) return '-';
          return new Date(value).toLocaleDateString('de-DE');
        },
      },
      hideExpression: () => !this.isTask3EvaluateOfferInquiry,
    },
    {
      key: 'status',
      type: 'input',
      wrappers: ['readOnly'],
      props: {
        label: this.translate('label__actualStatus'),
        tooltip: this.translateService.instant(
          'taskmodule.task.offer.tooltip.actualStatus'
        ),
        readOnly: true,
      },
    },
  ];

  detailFields: IDetailFields[] = [
    {
      type: 'buffered-files',
      key: 'documentMetadata',
    },
    {
      type: 'typed-files',
      key: 'fmDocument',
    },
  ];

  isOPLExt = false;

  description = '';
  descriptionStyle: string;
  descriptionContainerStyle: string;

  canDownload = true;

  isTask2EvaluateOffersAndCreateSuppliers: boolean;

  isTask3EvaluateOfferInquiry: boolean;

  isTask7ExecuteOptionalService: boolean;

  isTask11SubmitInvoiceToScanCenter: boolean;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private optionSetClient: OptionSetClient,
    private cd: ChangeDetectorRef,
    private translateDataService: TranslateDataService,
    private translateService: TranslateService,
    private taskClient: TaskClient,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private ibpdiHelperService: IbpdiHelperService,
    private breadcrumbService: BreadcrumbService,
    private incidentClient: IncidentClient,
    private taskExcelExportService: TaskExcelExportService,
    private taskEquipmentService: TaskEquipmentService,
    private organisationClient: OrganisationClient
  ) {
    this.organisationClient
      .getAdminPortalRelevantOrSupplier()
      .pipe(first())
      .subscribe(orgs =>
        orgs.forEach(org => {
          if (org.id) this.organisationMap.set(org.id, org);
        })
      );
  }

  ngOnInit() {
    this.restoreWideLayoutPreference();

    this.initializeContactUsForm();
    this.description = this.translateService.instant(
      'ticket.summary.contact.hint'
    );
    this.descriptionStyle =
      'background-color: #E20074; color: white; border-radius: 5px; padding: 15px;';
    this.descriptionContainerStyle =
      'width: 100%; max-width: 840px; border-radius: 15px; padding: 0 15px;';

    const originRoute = history.state?.originRoute;
    const backUrl =
      originRoute === 'tickets'
        ? '/tickets'
        : originRoute === 'tickets_dtag'
          ? '/tickets_dtag'
          : originRoute === 'taskList'
            ? '/tasks'
            : '/tickets';
    const backLabel =
      originRoute === 'tickets'
        ? this.translateService.instant('taskmodule.tickets.list.title_dl')
        : originRoute === 'tickets_dtag'
          ? this.translateService.instant('taskmodule.tickets.list.title')
          : originRoute === 'taskList'
            ? this.translateService.instant('taskmodule.task.list.title_dl')
            : this.translateService.instant('taskmodule.tickets.list.title');
    setTimeout(() => {
      this.breadcrumbService.setBreadcrumbs([
        {
          label: backLabel,
          onClick: () => {
            this.router.navigateByUrl(backUrl);
          },
        },
        {
          label: this.title,
        },
      ]);
    }, 0);

    this.getItem(this.route.snapshot.paramMap.get('id'));

    this.route.queryParams.subscribe(params => {
      const tab = params['tab'];
      if (tab) {
        this.setActiveTab(tab);
      }
    });
  }

  setActiveTab(tabId: string) {
    const tab = this.tabs.find(t => t.id === tabId);
    if (tab) {
      this.activeTab = tab.id;
    }
  }

  getItem(id: string | null) {
    if (!id) {
      return;
    }
    this.isLoading = true;
    this.taskClient
      .getTask(id, true)
      .pipe(first())
      .subscribe({
        next: (
          data: ResultExtensionWrapperOfTaskViewModelAndIEnumerableOfIncidentFieldMapping
        ) => {
          this.isLoading = false;
          this.cd.detectChanges();

          if (!data) {
            this.showErrorToastLoadTask();
            this.cd.detectChanges();
            return;
          }

          this.entity = data;
          this.task = data.entity;
          this.dataContactAddress = data.entity.incident;
          this.extension = data.extension;

          this.isTask2EvaluateOffersAndCreateSuppliers =
            this.task?.subject ===
            TaskSubject.OPL_EXT_EVALUATE_OFFERS_AND_CREATE_SUPPLIERS;

          this.isTask3EvaluateOfferInquiry =
            this.task?.subject === TaskSubject.OPL_EXT_EVALUATE_OFFER_INQUIRY;

          this.isTask7ExecuteOptionalService =
            this.task?.subject === TaskSubject.OPL_EXT_EXECUTE_OPTIONAL_SERVICE;

          this.isTask11SubmitInvoiceToScanCenter =
            this.task?.subject ===
            TaskSubject.OPL_EXT_SUBMIT_INVOICE_TO_SCAN_CENTER;

          if (
            data.entity?.incident?.incidentClass?.incidentClass ===
            IncidentClass.OptionalServicesExternal
          ) {
            this.isOPLExt = true;
          }

          this.formFields = this.isOPLExt
            ? [...this.incidentOPLExtInformations]
            : [...this.incidentInformations, ...this.taskInformations];

          if (this.isOPLExt) {
            const fmIncidentArchObj =
              this.task?.incident?.fmIncidentArchObj || [];
            const equipmentByArchObjId =
              this.taskEquipmentService.buildEquipmentByArchObjId(this.task);
            const equipmentColumns =
              this.taskEquipmentService.buildEquipmentColumns();
            const frameworkContractId =
              this.task?.incident?.fmServiceRequestExternal
                ?.frameworkContractId;

            this.isDummyFrameworkContract = frameworkContractId?.startsWith(
              'frameworkContract-1000'
            );

            const equipmentFilterDate: Date | undefined = (() => {
              const sortedQRs = [...(this.task?.incident?.fmQuotationRequest || [])].sort(
                (a, b) => new Date(b.changeDate || 0).getTime() - new Date(a.changeDate || 0).getTime()
              );
              return sortedQRs[0]?.changeDate ? new Date(sortedQRs[0].changeDate) : undefined;
            })();

            let locationsField: FormlyFieldConfig | null = null;

            if (
              this.isTask7ExecuteOptionalService ||
              this.isTask11SubmitInvoiceToScanCenter
            ) {
              const allPurchaseOrders =
                this.task?.incident?.fmPurchaseOrder || [];
              const sortedPurchaseOrders = [...allPurchaseOrders].sort(
                (a, b) =>
                  new Date(
                    b.orderDate || (b as any).changeDate || 0
                  ).getTime() -
                  new Date(a.orderDate || (a as any).changeDate || 0).getTime()
              );

              const purchaseOrdersWithQuotationLines =
                sortedPurchaseOrders.filter(
                  purchaseOrder =>
                    this.getQuotationLinesFromPurchaseOrder(purchaseOrder)
                      .length > 0
                );

              const documentsByQuotationLineId =
                getServiceRegistrationDocumentsByQuotationLineId(
                  this.task,
                  this.task?.configurationTask?.defaultDocumentTypeId
                );

              const purchaseOrderQuotationLines =
                purchaseOrdersWithQuotationLines
                  .flatMap(purchaseOrder =>
                    this.enrichQuotationLinesWithPurchaseOrderData(
                      this.getQuotationLinesFromPurchaseOrder(purchaseOrder),
                      purchaseOrder
                    ).map(line => ({
                      ...line,
                      purchaseOrder,
                      orderNumber: purchaseOrder?.orderNumber,
                      archObj:
                        line.archObj ||
                        this.task?.incident?.fmIncidentServiceLine?.find(
                          (sl: any) => sl.archObjId === line.archObjId
                        )?.archObj,
                      serviceRegistrationDocumentationFiles:
                        documentsByQuotationLineId.get(line?.id || '') || [],
                    }))
                  )
                  .sort(
                    (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
                  );

              this.editedLocations = this.getLatestAddendumQuotationLines();

              const hasServiceRegistrationData =
                purchaseOrderQuotationLines.some(location =>
                  this.hasServiceRegistrationData(location)
                );

              this.serviceRegistrationLocations = hasServiceRegistrationData
                ? this.prepareServiceRegistrationLocationsForView(
                    purchaseOrderQuotationLines
                  )
                : [];

              this.locations = hasServiceRegistrationData
                ? this.serviceRegistrationLocations
                : purchaseOrderQuotationLines;

              const purchaseOrderNumber =
                purchaseOrdersWithQuotationLines
                  .map(purchaseOrder => purchaseOrder?.orderNumber)
                  .filter((orderNumber): orderNumber is string => !!orderNumber)
                  .filter(
                    (orderNumber, index, orderNumbers) =>
                      orderNumbers.indexOf(orderNumber) === index
                  )
                  .join(', ') || '-';

              const columnsToUse = hasServiceRegistrationData
                ? this.getServiceRegistrationColumnsForView()
                : this.serviceLineColumns
                    .filter(
                      (col: any) => col.field !== 'serviceProviderComment'
                    )
                    .map((col: any) => {
                      if (col.field === 'quantity') {
                        return {
                          ...col,
                          header: this.translateService.instant(
                            'taskmodule.task.offer.order_quantity'
                          ),
                        };
                      }
                      if (col.field === 'totalPrice') {
                        return {
                          ...col,
                          header: this.translateService.instant(
                            this.isTask11SubmitInvoiceToScanCenter
                              ? 'taskmodule.task.offer.invoice_value'
                              : 'taskmodule.task.offer.order_price'
                          ),
                          formatter: (row: any) => {
                            const quantity =
                              parseFloat(String(row?.quantity)) || 0;
                            const unitPrice =
                              parseFloat(String(row?.unitPrice)) || 0;
                            return `${formatPrice(quantity * unitPrice)} €`;
                          },
                        };
                      }
                      return col;
                    });

              const equipmentFilterDateTask7: Date | undefined = (() => {
                const quotations = purchaseOrdersWithQuotationLines.flatMap((po: any) => {
                  const rawQ = po.fmQuotation || po.quotation;
                  return Array.isArray(rawQ) ? rawQ : rawQ ? [rawQ] : [];
                }).filter((q: any) => q && !this.isAddendumQuotation(q));
                const sorted = [...quotations].sort(
                  (a: any, b: any) => new Date(b.changeDate || 0).getTime() - new Date(a.changeDate || 0).getTime()
                );
                return sorted[0]?.changeDate ? new Date(sorted[0].changeDate) : undefined;
              })();

              locationsField = {
                key: 'locationsExpandable',
                type: 'locations-expandable',
                props: {
                  headline:
                    this.translateService.instant(
                      this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.locations_billable_positions_order'
                        : 'taskmodule.task.offer.locations_offer_positions_order'
                    ) || 'Standorte',
                  headlineTooltip: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                        ? 'taskmodule.task.offer.tooltip.locations.billable_positions'
                        : 'taskmodule.task.offer.tooltip.locations.offer_positions_order'
                  ),
                  locations: this.locations,
                  serviceLineColumns: columnsToUse,
                  fmIncidentArchObj,
                  orderNumber: purchaseOrderNumber,
                  locationSumLabel: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.invoice_value_location'
                      : 'taskmodule.task.offer.order_price_location'
                  ),
                  totalSumLabel: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.invoice_value_total'
                      : 'taskmodule.task.offer.order_sum_total'
                  ),
                  usePurchaseOrderLineNetPrice: false,
                  isOfferPosition: false,
                  equipmentByArchObjId,
                  equipmentColumns,
                  equipmentFilterDate: equipmentFilterDateTask7,
                  receiptLocationSumLabel: this.translateService.instant(
                    'taskmodule.task.offer.service_receipt_location_sum_label'
                  ),
                  receiptTotalSumLabel: this.translateService.instant(
                    'taskmodule.task.offer.service_receipt_total_sum_label'
                  ),
                  sumQuantityField: 'quantityProvided',
                  disableEquipmentDocumentationUpload: true,
                },
              };
            } else {
              if (
                this.isDummyFrameworkContract &&
                this.isTask3EvaluateOfferInquiry
              ) {
                const sortedQuotationRequests = [
                  ...(this.task?.incident?.fmQuotationRequest || []),
                ].sort(
                  (a, b) =>
                    new Date(b.changeDate).getTime() -
                    new Date(a.changeDate).getTime()
                );
                const quotationRequest = sortedQuotationRequests[0];
                this.locations = (
                  quotationRequest?.fmQuotationRequestLine || []
                ).sort((a, b) => (a.recordNumber || 0) - (b.recordNumber || 0));
              } else {
                this.locations = (
                  this.task?.incident?.fmIncidentServiceLine || []
                ).sort((a, b) => (a.recordNumber || 0) - (b.recordNumber || 0));
              }

              if (this.isTask3EvaluateOfferInquiry) {
                const allRequests =
                  this.task?.incident?.fmQuotationRequest || [];
                const hasMultipleRequests = allRequests.length > 1;
                const sortedRequests = [...allRequests].sort(
                  (a, b) =>
                    new Date(b.changeDate || 0).getTime() -
                    new Date(a.changeDate || 0).getTime()
                );
                const latestRequest = sortedRequests[0];
                const hasLocations =
                  (latestRequest?.fmQuotationRequestLine?.length || 0) > 0;

                this.formFields.push({
                  fieldGroupClassName: 'button-row-container',
                  fieldGroup: [
                    {
                      type: 'button',
                      hideExpression: () => !hasMultipleRequests,
                      props: {
                        label: this.translateService.instant(
                          'taskmodule.task.offer.view_previous_offers'
                        ),
                        tooltip: this.translateService.instant(
                          'taskmodule.task.offer.tooltip.view_previous_offers'
                        ),
                        color: 'primary',
                        onClick: () => this.showHistory(),
                        disabled: !hasLocations,
                      },
                    },
                  ],
                });
              }

              const columnsToUse =
                this.isDummyFrameworkContract &&
                this.isTask3EvaluateOfferInquiry
                  ? this.getServiceLineColumnsForDummyOfferInquiry(true)
                  : this.serviceLineColumns.filter(
                      col => col.field !== 'serviceProviderComment'
                    );

              const columnsForTable = [...columnsToUse];
              if (this.isTask2EvaluateOffersAndCreateSuppliers) {
                const totalPriceIndex = columnsForTable.findIndex(
                  col => col.field === 'totalPrice'
                );
                const priceNegotiatedColumn: any = {
                  header: this.translateService.instant(
                    'taskmodule.task.offer.negotiated_price'
                  ),
                  field: 'priceNegotiated',
                  sortable: false,
                  width: '140px',
                  formatter: (row: any) =>
                    row?.priceNegotiated
                      ? this.translate('label__choice_yes')
                      : this.translate('label__choice_no'),
                };

                if (totalPriceIndex !== -1) {
                  columnsForTable.splice(
                    totalPriceIndex + 1,
                    0,
                    priceNegotiatedColumn as any
                  );
                } else {
                  columnsForTable.push(priceNegotiatedColumn as any);
                }
              }

              locationsField = {
                key: 'locationsExpandable',
                type: 'locations-expandable',
                props: {
                  headline:
                    this.translateService.instant(
                      'taskmodule.task.offer.locations_offer'
                    ) || 'Standorte',
                  headlineTooltip: this.translateService.instant(
                    'taskmodule.task.offer.tooltip.locations.base'
                  ),  
                  locations: this.locations,
                  serviceLineColumns: columnsForTable,
                  fmIncidentArchObj,
                  hideSums: false,
                  isDummyFrameworkContract: this.isDummyFrameworkContract,
                  respectPriceNegotiatedForDummy:
                    this.isDummyFrameworkContract &&
                    this.isTask3EvaluateOfferInquiry,
                  isOfferPosition: false,
                  sumAllRows: this.isTask2EvaluateOffersAndCreateSuppliers,
                  equipmentByArchObjId,
                  equipmentColumns,
                  equipmentFilterDate: this.isTask2EvaluateOffersAndCreateSuppliers
                    ? undefined
                    : equipmentFilterDate,
                  hideEquipmentWithDeleteDate: this.isTask2EvaluateOffersAndCreateSuppliers,
                  disableEquipmentDocumentationUpload: true,
                },
              };
            }

            if (this.isTask2EvaluateOffersAndCreateSuppliers) {
              this.formFields = this.formFields.map(card => ({
                ...card,
                fieldGroup: card.fieldGroup?.map(group => {
                  const fields = group.fieldGroup || [];
                  const purchasingInfoIndex = fields.findIndex(
                    f =>
                      f.key ===
                      'incident.fmServiceRequestExternal.purchasingInformation'
                  );
                  if (purchasingInfoIndex !== -1 && locationsField) {
                    const newFields = [...fields];
                    newFields.splice(
                      purchasingInfoIndex + 1,
                      0,
                      locationsField
                    );
                    return { ...group, fieldGroup: newFields };
                  }
                  return group;
                }),
              }));
            } else if (locationsField) {
              this.formFields.push(locationsField);
            }

            // If Quotation with QuotationLines exists, show them as offer positions
            if (this.isTask3EvaluateOfferInquiry) {
              const sortedQuotationRequests = [
                ...(this.task?.incident?.fmQuotationRequest || []),
              ].sort(
                (a, b) =>
                  new Date(b.changeDate).getTime() -
                  new Date(a.changeDate).getTime()
              );
              const quotationRequest = sortedQuotationRequests[0];
              const latestQuotation = quotationRequest?.fmQuotation?.[0];

              if (
                latestQuotation?.fmQuotationLine &&
                latestQuotation.fmQuotationLine.length > 0
              ) {
                const requestLines =
                  (quotationRequest?.fmQuotationRequestLine as any[]) || [];
                const sortedQuotationLines = latestQuotation.fmQuotationLine
                  .map(line => {
                    const matchingRequestLine = requestLines.find(
                      (requestLine: any) =>
                        requestLine.id === line.quotationRequestLineId ||
                        (requestLine.recordNumber === line.recordNumber &&
                          requestLine.archObjId === line.archObjId)
                    );

                    return {
                      ...line,
                      priceNegotiated:
                        (line as any).priceNegotiated ??
                        (matchingRequestLine as any)?.priceNegotiated ??
                        false,
                    };
                  })
                  .sort(
                    (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
                  );

                this.formFields.push({
                  key: 'editedLocationsExpandable',
                  type: 'locations-expandable',
                  props: {
                    headline: this.translateService.instant(
                      'taskmodule.task.offer.locations_offer_positions'
                    ),
                    locations: sortedQuotationLines,
                    serviceLineColumns: this.serviceLineColumns,
                    fmIncidentArchObj,
                    isDummyFrameworkContract: this.isDummyFrameworkContract,
                    totalSumLabel: this.translateService.instant(
                      'taskmodule.task.offer.total_offer_positions_label'
                    ),
                    isOfferPosition: true,
                    equipmentByArchObjId,
                    equipmentColumns,
                    equipmentFilterDate,
                    disableEquipmentDocumentationUpload: true,
                  },
                });
              }
            }

            if (
              (this.isTask7ExecuteOptionalService ||
                this.isTask11SubmitInvoiceToScanCenter) &&
              this.editedLocations.length > 0
            ) {
              this.formFields.push({
                key: 'editedLocationsExpandable',
                type: 'locations-expandable',
                props: {
                  headline: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.locations_billable_addendum_positions'
                      : 'taskmodule.task.offer.locations_addendum_positions'
                  ),
                  headlineTooltip: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.tooltip.locations.billable_addendum_positions'
                      : 'taskmodule.task.offer.tooltip.locations.addendum_positions'
                  ),
                  locations: this.getAddendumLocationsForDisplay(
                    this.editedLocations
                  ),
                  serviceLineColumns: this.isTask11SubmitInvoiceToScanCenter
                    ? this.serviceLineColumns.map(col => {
                        if (col.field !== 'totalPrice') {
                          return col;
                        }
                        return {
                          ...col,
                          header: this.translateService.instant(
                            'taskmodule.task.offer.invoice_value'
                          ),
                          formatter: (row: any) => {
                            const quantity =
                              parseFloat(String(row?.quantity)) || 0;
                            const unitPrice =
                              parseFloat(String(row?.unitPrice)) || 0;
                            return `${formatPrice(quantity * unitPrice)} €`;
                          },
                        };
                      })
                    : this.editedLocations.some(loc =>
                          this.hasServiceRegistrationData(loc)
                        )
                      ? this.getServiceRegistrationColumnsForView()
                      : this.serviceLineColumns,
                  fmIncidentArchObj,
                  locationSumLabel: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.invoice_value_addendum_location'
                      : 'taskmodule.task.offer.total_location_label'
                  ),
                  totalSumLabel: this.translateService.instant(
                    this.isTask11SubmitInvoiceToScanCenter
                      ? 'taskmodule.task.offer.invoice_value_addendum_total'
                      : 'taskmodule.task.offer.total_addendum_positions_label'
                  ),
                  receiptLocationSumLabel: !this.isTask11SubmitInvoiceToScanCenter
                    ? this.translateService.instant(
                        'taskmodule.task.offer.service_receipt_location_sum_label'
                      )
                    : undefined,
                  receiptTotalSumLabel: !this.isTask11SubmitInvoiceToScanCenter
                    ? this.translateService.instant(
                        'taskmodule.task.offer.service_receipt_total_sum_label'
                      )
                    : undefined,
                  sumQuantityField: !this.isTask11SubmitInvoiceToScanCenter
                    ? 'quantityProvided'
                    : undefined,
                  isOfferPosition: true,
                  showAddendumStatusReason: true,
                  showAddendumCommentDisplay: true,
                  addendumStatusReason: this.getLatestAddendumStatusReason(),
                  addendumComment:
                    this.getLatestAddendumQuotation()?.serviceProviderComment ||
                    '',
                  addendumInternalComment:
                    this.getLatestAddendumQuotation()?.internalComment || '',
                },
              });
            }

            this.formFields.push(...this.taskOPLExtInformations);

            this.tabs.push({
              label: this.translateService.instant(
                'taskmodule.shared.label__contact_us'
              ),
              id: 'contactUs',
              onClick: (id: string) => this.onTabClick(id),
            });
          } else {
            this.fillIncidentAttributeForm();
          }

          const fileMetadata = [
            {
              attributeName: 'incidentId',
              attributeValue: data.entity?.incidentId || 'error no incidentId',
            },
            {
              attributeName: 'taskId',
              attributeValue: data.entity?.taskId || 'error no taskId',
            },
            {
              attributeName: 'visibilityId',
              attributeValue: DocumentVisibility.InternAndContractors,
            },
          ];

          this.detailFields.forEach((detailField: IDetailFields) => {
            detailField.fileMetadata = fileMetadata;
          });

          const quotationRequestForModel =
            this.task?.incident?.fmQuotationRequest?.[0];
          const latestQuotationForModel =
            quotationRequestForModel?.fmQuotation?.[0];
          const quotationValidUntil = latestQuotationForModel?.validUntil
            ? new Date(latestQuotationForModel.validUntil)
            : null;

          this.formModel = {
            ...this.formModel,
            ...data.entity,
            validUntil: quotationValidUntil,
          };
          this.cd.detectChanges();
        },
        error: error => {
          this.isLoading = false;
          this.showErrorToastLoadTask();
          this.cd.detectChanges();
          console.log(error);
        },
      });
  }

  private showErrorToastLoadTask() {
    this.toastr.error(
      this.translateService.instant('crud.details.error.failed_to_load_msg'),
      this.translateService.instant('crud.details.error.failed_to_load_title'),
      { timeOut: 0 }
    );
  }

  private showErrorToastUpdateTask() {
    this.toastr.error(
      this.translateService.instant('crud.update.error.failed_to_update_msg'),
      this.translateService.instant('crud.update.error.failed_to_update_title'),
      { timeOut: 0 }
    );
  }

  private showSuccessToastUpdateTask() {
    this.toastr.success(
      this.translateService.instant('crud.update.success.sucess_update_msg'),
      this.translateService.instant('crud.update.success.sucess_update_title'),
      { timeOut: 0 }
    );
  }

  submit() {
    if (!this.task || !this.task.incidentId) {
      return;
    }

    this.isLoading = true;
    this.cd.detectChanges();

    if ((this.form.value as any).newStatus === TaskStatus.Abgeschlossen) {
      const taskClosedDialog: MatDialogRef<DialogComponent> = this.dialog.open(
        DialogComponent,
        {
          width: '500px',
          data: {
            type: 'okDismissButton',
            title: 'Aufgabe wird abgeschlossen',
            message:
              'Abgeschlossene oder stornierte Aufgaben können nicht mehr bearbeitet werden und werden in der Übersicht nicht mehr angezeigt.',
            okButtonText: 'Jetzt senden',
            dismissButtonText: 'Abbrechen',
          },
        }
      );

      taskClosedDialog
        .afterClosed()
        .pipe(first())
        .subscribe({
          next: res => {
            if (!res) {
              this.isLoading = false;
              this.cd.detectChanges();
              return;
            }
            this.send();
          },
        });
    } else {
      this.send();
    }
  }

  private send() {
    if (this.task && this.task.taskId) {
      const updateTaskDto: UpdateTaskDTO = {
        result: (this.form.value as any).result,
        status: (this.form.value as any).newStatus,
        taskId: this.task.taskId,
        updateIncidentDTO: this.generateUpdateIncidentDTO(),
      };
      this.taskClient
        .updateTask(updateTaskDto)
        .pipe(take(1))
        .subscribe({
          next: () => {
            this.isLoading = false;
            this.showSuccessToastUpdateTask();
            this.cd.detectChanges();
          },
          error: err => {
            console.error(err);
            this.isLoading = false;
            this.showErrorToastUpdateTask();
            this.cd.detectChanges();
          },
        });
    }
  }

  private generateUpdateIncidentDTO(): UpdateIncidentDTO {
    const incidentDto: FmIncident = {
      name: this.task?.incident?.name,
      incidentId: this.task?.incident?.incidentId,
      pmIncidentExternalLetting: this.task?.incident?.pmIncidentExternalLetting,
      pmIncidentRealEstateDecision:
        this.task?.incident?.pmIncidentRealEstateDecision,
      pmIncidentRentalContractMgmtIdNavigation:
        this.task?.incident?.pmIncidentRentalContractMgmtIdNavigation,
      ...this.form.value[this.updateIncidentFieldGroupName],
    };
    return {
      incident: incidentDto,
      fieldMapping: this.extension || [],
    };
  }

  private fillIncidentAttributeForm() {
    if (
      !this.task ||
      !this.task.configurationTask ||
      !this.task.configurationTask.fmConfigurationRow ||
      !this.task.incident ||
      this.task.configurationTask.fmConfigurationRow.length <= 0
    ) {
      return;
    }

    // add chapter title
    this.formFields.push({
      type: 'chapter',
      props: {
        chapterTitle: this.translateService.instant(
          'taskmodule.task.view.view_incident_fields'
        ),
      },
    });

    // generate emtpy FormGroup for the incident fields
    const updateIncidentFormGroup: {
      key: string;
      fieldGroup: Array<any>;
    } & FormlyFieldConfig = {
      key: this.updateIncidentFieldGroupName,
      fieldGroup: [],
    };

    // populate FormGroup with proper typed input fields
    for (const row of this.task.configurationTask.fmConfigurationRow) {
      // push generaded field in formGroup
      updateIncidentFormGroup.fieldGroup.push(
        this.generateConfigurationRowField(row)
      );
    }

    // push the formGroup in the parent formFields
    this.formFields.push(updateIncidentFormGroup);
  }

  private firstLowercase(theString: string): string {
    return theString.charAt(0).toLowerCase() + theString.slice(1);
  }

  private generateConfigurationRowField(
    row: FmConfigurationRow
  ): FormlyFieldConfig {
    if (!this.extension || !row.name || !this.task || !this.task.incident) {
      throw new Error('An Error occured in generateField');
    }

    // get mapping for fieldType of the configuration row
    const incidentFieldMapping: IncidentFieldMapping | null =
      this.extension.find(e => e.ibpdiAttributeName === row.name) || null;

    if (!incidentFieldMapping) {
      throw new Error('missing incidentFieldMapping');
    }

    const label: string = this.translateDataService.translate(
      row.titleDe,
      row.titleEn
    );

    const key: string = this.firstLowercase(row.name);

    const fieldType: string = incidentFieldMapping
      ? incidentFieldMapping.ibpdiAttributeType
      : '';

    // prefill field value with value in incident
    var defaultValue = null;

    if (incidentFieldMapping.targetEntity == null) {
      defaultValue = this.task.incident[key] || null;
    } else if (
      incidentFieldMapping.targetEntity == 'affinis_incidentrealestatedecision'
    ) {
      defaultValue =
        this.task.incident.pmIncidentRealEstateDecision[key] || null;
    } else if (
      incidentFieldMapping.targetEntity == 'affinis_incidentexternalletting'
    ) {
      defaultValue = this.task.incident.pmIncidentExternalLetting[key] || null;
    } else if (
      incidentFieldMapping.targetEntity ==
      'affinis_incidentrentalcontractmanagement'
    ) {
      defaultValue =
        this.task.incident.pmIncidentRentalContractMgmtIdNavigation[key] ||
        null;
    }

    if (fieldType.includes('String')) {
      return this.generateTextField(key, label, defaultValue);
    }
    if (fieldType.includes('DateTime')) {
      return this.generateDateField(key, label, defaultValue);
    }
    if (fieldType.includes('Int')) {
      return this.generateIntField(key, label, defaultValue);
    }
    if (fieldType.includes('Decimal')) {
      return this.generateDecimalField(key, label, defaultValue);
    }
    if (fieldType.includes('SysEnum')) {
      if (!incidentFieldMapping.optionSetType) {
        throw new Error('Missing optionSetType');
      }
      return this.generateOptionSetField(
        incidentFieldMapping.optionSetType,
        defaultValue,
        key,
        label
      );
    }
    if (fieldType.includes('Boolean')) {
      return this.generateBooleanField(key, label, defaultValue);
    }
    throw new Error(`Unknown fieldType: ${fieldType}`);
  }

  public generateTextField(
    key = '--',
    label = '--',
    defaultValue = '',
    maxLength = 100
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue,
      props: {
        label,
        maxLength,
        readonly: true,
        disabled: true,
      },
    };
  }

  private generateDateField(
    key = '--',
    label = '--',
    defaultValue = ''
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue: this.formatDateString(new Date(defaultValue)),
      props: {
        label,
        readonly: true,
        disabled: true,
      },
    };
  }

  private generateIntField(
    key = '--',
    label = '--',
    defaultValue = ''
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue,
      props: {
        type: 'number',
        label,
        readonly: true,
        disabled: true,
      },
    };
  }

  private generateDecimalField(
    key = '--',
    label = '--',
    defaultValue = ''
  ): FormlyFieldConfig {
    return {
      key,
      type: 'input',
      defaultValue,
      props: {
        type: 'number',
        label,
        step: 0.01,
        readonly: true,
        disabled: true,
      },
    };
  }

  private generateOptionSetField(
    optionSetType: string,
    defaultValue: SysEnum,
    key = '--',
    label = '--'
  ): FormlyFieldConfig {
    // fixes requiredness of sysEnumTranslation.name
    if (defaultValue) {
      delete defaultValue.sysEnumTranslation;
    }

    return {
      key,
      type: 'select',
      defaultValue,
      wrappers: ['form-field'], // todo check this wrapper : , 'loading-suffix'],
      props: {
        loading: false,
        readonly: true,
        disabled: true,
        compareWith(o1: any, o2: any) {
          return o1?.id === o2?.id;
        },
        label,
      },
      hooks: {
        onInit: (field: FormlyFieldConfig | undefined) => {
          if (!field || !field.props) {
            return;
          }
          const f = field.props;
          f.loading = true;
          f.readonly = true;
          f.disabled = true;
          this.cd.detectChanges();

          this.optionSetClient
            .getOptionSetByString(optionSetType)
            .pipe(
              first(),
              map(sysEnums => {
                return sysEnums.map((sysEnum: SysEnum) => {
                  delete sysEnum.sysEnumTranslation;
                  const s = { ...sysEnum };
                  return {
                    label:
                      this.ibpdiHelperService.getTranslatedEnumLable(sysEnum),
                    value: s,
                  };
                });
              })
            )
            .subscribe({
              next: options => {
                // sysEnumTranslation:null fixes requiredness of sysEnumTranslation.name
                if (defaultValue) {
                  delete defaultValue.sysEnumTranslation;
                }

                f.options = options;
                f.readonly = true;
                f.disabled = true;
                this.form.patchValue({
                  [this.updateIncidentFieldGroupName]: { [key]: defaultValue },
                });
                f.loading = false;
                f.readonly = true;
                f.disabled = true;
                this.cd.detectChanges();
              },
              error: error => {
                this.showErrorToastLoadTask();
                console.error(error);
              },
            });
        },
      },
    };
  }

  private generateBooleanField(
    key = '--',
    label = '--',
    defaultValue: boolean | null | string = null
  ): FormlyFieldConfig {
    if (defaultValue === '') {
      defaultValue = null;
    }

    const options: { id: number; label: string; value: boolean }[] = [
      { id: 1, label: this.translate('label__choice_yes'), value: true },
      { id: 2, label: this.translate('label__choice_no'), value: false },
    ];

    return {
      key,
      type: 'select',
      defaultValue,
      props: {
        options,
        label,
        readonly: true,
        disabled: true,
      },
    };
  }

  public translate(key: string) {
    return this.translateService.instant(`taskmodule.shared.${key}`);
  }

  private formatDateString(date: Date): string {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }

  private getServiceLineColumnsForDummyOfferInquiry(
    hideServiceProviderComment = false
  ): any[] {
    return this.serviceLineColumns
      .map(col => {
        if (col.field === 'unitPrice') {
          return {
            ...col,
            formatter: (row: any) => {
              const isPriceNegotiated = !!row?.priceNegotiated;
              const unitPrice = parseFloat(row?.unitPrice) || 0;
              return `${formatPrice(isPriceNegotiated ? unitPrice : 0)} €`;
            },
          };
        }

        if (col.field === 'totalPrice') {
          return {
            ...col,
            formatter: (row: any) => {
              const isPriceNegotiated = !!row?.priceNegotiated;
              const quantity = parseFloat(row?.quantity) || 0;
              const unitPrice = isPriceNegotiated
                ? parseFloat(row?.unitPrice) || 0
                : 0;
              return `${formatPrice(quantity * unitPrice)} €`;
            },
          };
        }

        return col;
      })
      .filter(col =>
        hideServiceProviderComment
          ? col.field !== 'serviceProviderComment'
          : true
      );
  }

  private getTask7ViewColumns(): any[] {
    return this.serviceLineColumns
      .filter(col => col.field !== 'serviceProviderComment')
      .map(col => {
        if (col.field === 'quantity') {
          return {
            ...col,
            header: this.translateService.instant(
              'taskmodule.task.offer.order_quantity'
            ),
          };
        }

        if (col.field === 'totalPrice') {
          return {
            ...col,
            header: this.translateService.instant(
              'taskmodule.task.offer.order_price'
            ),
          };
        }

        return col;
      });
  }

  get isTask2_3_7_11(): boolean {
    return (
      this.isTask2EvaluateOffersAndCreateSuppliers ||
      this.isTask3EvaluateOfferInquiry ||
      this.isTask7ExecuteOptionalService ||
      this.isTask11SubmitInvoiceToScanCenter
    );
  }

  get taskSubjectHeadline(): string {
    return this.task?.subject ?? this.formModel?.subject ?? '';
  }

  get canShowOrderedAddendumQuotationButton(): boolean {
    if (!this.isTask7ExecuteOptionalService) {
      return false;
    }
    return !!this.getLatestAcceptedAddendumQuotation();
  }

  showOrderedQuotation() {
    if (!this.task?.incident?.fmQuotation) {
      return;
    }

    if (this.isPreviousOffersDialogOpening || this.previousOffersDialogRef) {
      return;
    }

    const columnsToUse = this.isDummyFrameworkContract
      ? this.getServiceLineColumnsForDummyOfferInquiry()
      : this.serviceLineColumns;

    const latestMainQuotation = [...(this.task?.incident?.fmQuotation || [])]
      .filter(
        (quotation: FmQuotation) =>
          quotation.type?.defaultName === QuotationTypes.Offer ||
          quotation.type?.defaultName === undefined ||
          quotation.type?.defaultName === null
      )
      .sort(
        (a, b) =>
          new Date(b.changeDate || 0).getTime() -
          new Date(a.changeDate || 0).getTime()
      )[0];

    this.openPreviousOffersDialog({
      title: this.translateService.instant(
        'taskmodule.task.offer.ordered_offer.dialog_title'
      ),
      noEntriesMessage: this.translateService.instant(
        'taskmodule.task.offer.ordered_offer.no_entry'
      ),
      quotations: latestMainQuotation ? [latestMainQuotation] : [],
      serviceLineColumns: columnsToUse,
      fmIncidentArchObj: this.task.incident.fmIncidentArchObj || [],
      isDummyFrameworkContract: this.isDummyFrameworkContract,
      equipmentByArchObjId: this.taskEquipmentService.buildEquipmentByArchObjId(this.task),
      equipmentColumns: this.taskEquipmentService.buildEquipmentColumns({ includeDocumentation: false }),
    });
  }

  showOrderedAddendumQuotation() {
    if (!this.task?.incident?.fmQuotation) {
      return;
    }

    if (this.isPreviousOffersDialogOpening || this.previousOffersDialogRef) {
      return;
    }

    const columnsToUse = this.isDummyFrameworkContract
      ? this.getServiceLineColumnsForDummyOfferInquiry()
      : this.serviceLineColumns;

    const latestAcceptedAddendumQuotation =
      this.getLatestAcceptedAddendumQuotation();

    this.openPreviousOffersDialog({
      title: this.translateService.instant(
        'taskmodule.task.offer.ordered_addendum_offer.dialog_title'
      ),
      noEntriesMessage: this.translateService.instant(
        'taskmodule.task.offer.ordered_addendum_offer.no_entry'
      ),
      quotations: latestAcceptedAddendumQuotation
        ? [latestAcceptedAddendumQuotation]
        : [],
      serviceLineColumns: columnsToUse,
      fmIncidentArchObj: this.task.incident.fmIncidentArchObj || [],
      isDummyFrameworkContract: this.isDummyFrameworkContract,
      equipmentByArchObjId: this.taskEquipmentService.buildEquipmentByArchObjId(this.task),
      equipmentColumns: this.taskEquipmentService.buildEquipmentColumns({ includeDocumentation: false }),
    });
  }

  private getLatestAddendumQuotation(): FmQuotation | undefined {
    return getLatestAddendumQuotationFromTask(
      this.task,
      this.addendumOfferTypeId
    );
  }

  private getLatestAddendumStatusReason(): string {
    return getLatestAddendumStatusReasonFromTask(
      this.task,
      this.addendumOfferTypeId
    );
  }

  private getAddendumLocationsForDisplay(locations: any[] = []): any[] {
    const latestAddendumQuotation = this.getLatestAddendumQuotation();
    return (locations || []).map((location: any) => {
      const incidentPurchaseOrders = this.task?.incident?.fmPurchaseOrder || [];
      const quotationId =
        (location as any)?.quotationId ||
        latestAddendumQuotation?.id ||
        (latestAddendumQuotation as any)?.quotationId;
      const resolvedPurchaseOrder =
        location?.purchaseOrder ||
        incidentPurchaseOrders.find(
          po =>
            po?.quotationId === quotationId ||
            (po?.fmQuotationLine || []).some(
              (ql: any) => ql?.archObjId === location?.archObjId
            )
        );
      return {
        ...location,
        purchaseOrder: resolvedPurchaseOrder || location?.purchaseOrder,
        orderNumber:
          location?.orderNumber ||
          resolvedPurchaseOrder?.orderNumber ||
          location?.purchaseOrder?.orderNumber,
      };
    });
  }

  private getLatestAcceptedAddendumQuotation(): FmQuotation | undefined {
    return getLatestAcceptedAddendumQuotationFromTask(
      this.task,
      this.addendumOfferTypeId
    );
  }

  private isAcceptedAddendumStatusReason(
    statusReason?: string | null
  ): boolean {
    return isAcceptedAddendumStatusReasonValue(statusReason);
  }

  showHistory() {
    if (!this.task?.incident?.fmQuotationRequest) {
      return;
    }

    if (this.isPreviousOffersDialogOpening || this.previousOffersDialogRef) {
      return;
    }

    const columnsToUse = this.isDummyFrameworkContract
      ? this.getServiceLineColumnsForDummyOfferInquiry()
      : this.serviceLineColumns;

    const sortedQuotationRequests = [
      ...this.task.incident.fmQuotationRequest,
    ].sort(
      (a, b) =>
        new Date(b.changeDate || 0).getTime() -
        new Date(a.changeDate || 0).getTime()
    );

    const historyQuotationRequests = sortedQuotationRequests.slice(1);

    this.isPreviousOffersDialogOpening = true;
    this.openPreviousOffersDialog({
      title: this.translateService.instant(
        'taskmodule.task.offer.previous_offers_title'
      ),
      noEntriesMessage: this.translateService.instant(
        'taskmodule.task.offer.no_offers'
      ),
      quotationRequests: historyQuotationRequests,
      serviceLineColumns: columnsToUse,
      fmIncidentArchObj: this.task.incident.fmIncidentArchObj || [],
      isDummyFrameworkContract: this.isDummyFrameworkContract,
      equipmentByArchObjId: this.taskEquipmentService.buildEquipmentByArchObjId(this.task),
      equipmentColumns: this.taskEquipmentService.buildEquipmentColumns({ includeDocumentation: false }),
    });
    this.isPreviousOffersDialogOpening = false;
  }

  private openPreviousOffersDialog(data: unknown): void {
    if (this.previousOffersDialogRef) {
      return;
    }

    this.previousOffersDialogRef = this.dialog.open(
      PreviousOffersDialogComponent,
      {
        panelClass: 'smartportal-dialog',
        width: '900px',
        maxHeight: '90vh',
        data,
      }
    );

    this.previousOffersDialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.previousOffersDialogRef = null;
      });
  }

  private getServiceRegistrationColumnsForView(): any[] {
    return [
      {
        header: this.translateService.instant('taskmodule.task.offer.number'),
        field: 'recordNumber',
        sortable: true,
        width: '60px',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.description'
        ),
        field: 'description',
        sortable: true,
        formatter: (row: any) => row.name || row.description || '',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.order_quantity'
        ),
        field: 'quantity',
        sortable: true,
        formatter: (row: any) => row.quantity ?? 0,
      },
      {
        header: this.translateService.instant('taskmodule.task.offer.unit'),
        field: 'unit.name',
        sortable: true,
        formatter: (row: any) => row.unit?.name || '',
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.unit_price'
        ),
        field: 'unitPrice',
        sortable: true,
        formatter: (row: any) => {
          const unitPrice = parseFloat(String(row?.unitPrice)) || 0;
          return `${formatPrice(unitPrice)} €`;
        },
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.order_price'
        ),
        field: 'totalPrice',
        sortable: true,
        formatter: (row: any) => {
          const quantity = parseFloat(String(row?.quantity)) || 0;
          const unitPrice = parseFloat(String(row?.unitPrice)) || 0;
          return `${formatPrice(quantity * unitPrice)} €`;
        },
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.quantity_service_receipt'
        ),
        field: 'quantityProvided',
        sortable: false,
        width: '120px',
        formatter: (row: any) => row?.quantityProvided ?? 0,
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.service_receipt_billable'
        ),
        field: 'serviceRegistrationBillableValue',
        sortable: false,
        width: '130px',
        formatter: (row: any) =>
          `${formatPrice(row?.serviceRegistrationBillableValue ?? 0)} €`,
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.documentation'
        ),
        field: 'serviceRegistrationDocumentation',
        sortable: false,
        width: '260px',
        formatter: (row: any) =>
          (row?.serviceRegistrationDocumentationFiles || [])
            .map((file: any) => file?.name)
            .filter((name: string | undefined): name is string => !!name)
            .join(', '),
      },
      {
        header: this.translateService.instant(
          'taskmodule.task.offer.comment_service_receipt'
        ),
        field: 'serviceRegistrationCommentExternal',
        sortable: false,
        width: '280px',
        formatter: (row: any) => row?.serviceRegistrationCommentExternal || '',
      },
      {
        header: this.translateService.instant('taskmodule.task.offer.status'),
        field: 'serviceReported',
        sortable: false,
        width: '130px',
        formatter: (row: any) => (row?.serviceReported ? 'Erledigt' : '--'),
      },
    ];
  }

  private hasServiceRegistrationData(location: any): boolean {
    return (
      parseFloat(String(location?.quantityProvided)) > 0 ||
      !!location?.serviceRegistrationCompletionDate ||
      !!location?.serviceRegistrationCommentExternal ||
      !!location?.serviceReported ||
      (location?.serviceRegistrationDocumentationFiles || []).length > 0
    );
  }

  private prepareServiceRegistrationLocationsForView(locations: any[]): any[] {
    return locations.map(location => {
      const quantityProvided = (location as any).quantityProvided ?? 0;
      const unitPrice = parseFloat(String((location as any).unitPrice)) || 0;

      return {
        ...location,
        quantityProvided,
        serviceRegistrationBillableValue:
          (parseFloat(String(quantityProvided)) || 0) * unitPrice,
        serviceRegistrationCompletionDate:
          (location as any).serviceRegistrationCompletionDate || null,
        serviceRegistrationDocumentationFiles:
          (location as any).serviceRegistrationDocumentationFiles || [],
        serviceRegistrationCommentExternal:
          (location as any).serviceRegistrationCommentExternal || '',
        serviceReported: !!(location as any).serviceReported,
      };
    });
  }

  private getQuotationLinesFromPurchaseOrder(
    purchaseOrder?: FmPurchaseOrder | any
  ): FmQuotationLine[] {
    if (!purchaseOrder) {
      return [];
    }

    const rawPurchaseOrderLines = purchaseOrder?.fmPurchaseOrderLine;
    const purchaseOrderLines: any[] = Array.isArray(rawPurchaseOrderLines)
      ? rawPurchaseOrderLines
      : rawPurchaseOrderLines
        ? [rawPurchaseOrderLines]
        : [];

    const purchaseOrderArchObjIds = new Set(
      purchaseOrderLines
        .map(purchaseOrderLine => purchaseOrderLine?.archObjId)
        .filter((archObjId): archObjId is string => !!archObjId)
    );

    const rawQuotations = purchaseOrder.fmQuotation || purchaseOrder.quotation;
    const quotations: any[] = Array.isArray(rawQuotations)
      ? rawQuotations
      : rawQuotations
        ? [rawQuotations]
        : [];

    const quotationLines = quotations
      .filter((quotation: any) => !this.isAddendumQuotation(quotation))
      .flatMap((quotation: any) => {
        const rawLines = quotation?.fmQuotationLine || quotation?.quotationLine;
        return Array.isArray(rawLines) ? rawLines : rawLines ? [rawLines] : [];
      })
      .filter(
        (quotationLine: any) =>
          !quotationLine?.isAddendumServiceRegistrationPosition
      );

    if (purchaseOrderArchObjIds.size === 0) {
      return quotationLines;
    }

    return quotationLines.filter(quotationLine =>
      purchaseOrderArchObjIds.has(quotationLine?.archObjId)
    );
  }

  private getLatestAddendumQuotationLines(): FmQuotationLine[] {
    return getLatestAddendumQuotationLinesFromTask(
      this.task,
      this.addendumOfferTypeId
    ) as FmQuotationLine[];
  }

  private getIncidentQuotations(): FmQuotation[] {
    return getIncidentQuotationsFromTask(this.task) as FmQuotation[];
  }

  private isAddendumQuotation(quotation: FmQuotation | any): boolean {
    return isAddendumQuotationByType(quotation, this.addendumOfferTypeId);
  }

  private enrichQuotationLinesWithPurchaseOrderData(
    quotationLines: FmQuotationLine[],
    purchaseOrder?: FmPurchaseOrder | any
  ): Array<FmQuotationLine & { purchaseOrderLine?: any; netPrice?: number }> {
    const rawPurchaseOrderLines = purchaseOrder?.fmPurchaseOrderLine;
    const purchaseOrderLines: any[] = Array.isArray(rawPurchaseOrderLines)
      ? rawPurchaseOrderLines
      : rawPurchaseOrderLines
        ? [rawPurchaseOrderLines]
        : [];

    const remainingPurchaseOrderLines = [...purchaseOrderLines];

    return quotationLines.map((quotationLine, index) => {
      const matchingIndex = remainingPurchaseOrderLines.findIndex(
        purchaseOrderLine =>
          purchaseOrderLine?.archObjId === quotationLine?.archObjId &&
          (purchaseOrderLine?.name === quotationLine?.name ||
            purchaseOrderLine?.quantity === quotationLine?.quantity ||
            remainingPurchaseOrderLines[index] === purchaseOrderLine)
      );

      const matchedPurchaseOrderLine =
        matchingIndex >= 0
          ? remainingPurchaseOrderLines.splice(matchingIndex, 1)[0]
          : remainingPurchaseOrderLines.shift();

      return {
        ...quotationLine,
        purchaseOrderLine: matchedPurchaseOrderLine,
        netPrice: matchedPurchaseOrderLine?.netPrice,
      };
    });
  }

  initializeContactUsForm(): void {
    this.formFieldsContactUs = [
      {
        fieldGroup: [
          {
            key: 'subject',
            type: 'input',
            props: {
              label: `${this.translateService.instant(
                'location.myLocation.location_notification.label__subject'
              )}:`,
              required: true,
            },
            validation: {
              messages: {
                required: this.translateService.instant('formErrors.required', {
                  label: this.translateService.instant(
                    'location.myLocation.location_notification.label__subject'
                  ),
                }),
              },
            },
          },
          {
            key: 'content',
            type: 'textarea',
            props: {
              label: `${this.translateService.instant(
                'ticket.summary.contact.content'
              )}:`,
              required: true,
              rows: 5,
            },
            validation: {
              messages: {
                required: this.translateService.instant('formErrors.required', {
                  label: this.translateService.instant(
                    'ticket.summary.contact.content'
                  ),
                }),
              },
            },
          },
        ],
      },
    ];
  }

  validateForm() {
    if (this.formContactUs.valid) {
      this.submitContactUsForm();
    }
  }

  private resetFormContactUs() {
    this.formContactUs = new FormGroup({});
    this.formModelContactUs = {} as IContactForm;
    this.initializeContactUsForm();
  }

  submitContactUsForm() {
    this.isLoading = true;
    this.cd.detectChanges();
    from(this.mapFormToRequest())
      .pipe(
        switchMap(request =>
          this.incidentClient.sendIncidentCommunication(request).pipe(
            finalize(() => {
              this.isLoading = false;
              this.cd.detectChanges();
            })
          )
        )
      )
      .subscribe({
        next: () => {
          this.toastr.success(
            this.translateService.instant(
              'location.myLocation.location_notification.success_message'
            )
          );
          this.resetFormContactUs();
        },
        error: () => {
          this.toastr.error(
            this.translateService.instant(
              'location.myLocation.location_notification.error_message'
            )
          );
        },
      });
  }

  private async mapFormToRequest(): Promise<SendIncidentCommunicationRequest> {
    const request: SendIncidentCommunicationRequest = {
      incidentId: this.task?.incident?.incidentId,
      incidentClass: this.task?.incident?.incidentClass?.incidentClass,
      subject: this.formModelContactUs.subject,
      message: this.formModelContactUs.content,
    };

    return request;
  }

  exportToExcel() {
    this.canDownload = false;

    const shouldUseDummyDisplayPrices =
      this.isDummyFrameworkContract && this.isTask3EvaluateOfferInquiry;

    const locations: FmIncidentServiceLine[] | FmQuotationRequestLine[] =
      shouldUseDummyDisplayPrices
        ? this.locations.map(location => ({
            ...location,
            unitPrice: (location as any).priceNegotiated
              ? parseFloat(String(location.unitPrice)) || 0
              : 0,
          }))
        : this.locations;
    const fmIncidentArchObj = this.task?.incident?.fmIncidentArchObj || [];

    let quotationLines: any[] = [];
    if (this.isTask3EvaluateOfferInquiry) {
      const quotationRequest = this.task?.incident?.fmQuotationRequest?.[0];
      const latestQuotation = quotationRequest?.fmQuotation?.[0];
      quotationLines = [...(latestQuotation?.fmQuotationLine || [])].sort(
        (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
      );
    } else if (
      this.isTask7ExecuteOptionalService &&
      this.editedLocations.length > 0
    ) {
      quotationLines = [...this.editedLocations].sort(
        (a, b) => (a.recordNumber || 0) - (b.recordNumber || 0)
      );
    }

    const hidePricesForLocations = false;

    const hidePurchasingInformation = this.isTask3EvaluateOfferInquiry;

    const hideAuxilaryAccountAssignment =
      this.isTask2EvaluateOffersAndCreateSuppliers ||
      this.isTask3EvaluateOfferInquiry;

    const showLocationsAfterPurchasingInfo =
      this.isTask2EvaluateOffersAndCreateSuppliers;

    // Für Aufgabe 2 & 3 keine Kommentar-Spalte
    let columnsForExport = this.serviceLineColumns;
    if (
      this.isTask2EvaluateOffersAndCreateSuppliers ||
      this.isTask3EvaluateOfferInquiry
    ) {
      columnsForExport = this.serviceLineColumns.filter(
        col => col.field !== 'serviceProviderComment'
      );
    }

    if (this.isTask2EvaluateOffersAndCreateSuppliers) {
      const totalPriceIndex = columnsForExport.findIndex(
        col => col.field === 'totalPrice'
      );
      const priceNegotiatedColumn: any = {
        header: this.translateService.instant(
          'taskmodule.task.offer.negotiated_price'
        ),
        field: 'priceNegotiated',
        sortable: false,
        width: '140px',
        formatter: (row: any) =>
          row?.priceNegotiated
            ? this.translate('label__choice_yes')
            : this.translate('label__choice_no'),
      };

      if (totalPriceIndex !== -1) {
        columnsForExport.splice(totalPriceIndex + 1, 0, priceNegotiatedColumn);
      } else {
        columnsForExport.push(priceNegotiatedColumn);
      }
    }

    const quotationLineColumnsForExport = this.isTask3EvaluateOfferInquiry
      ? this.serviceLineColumns
      : columnsForExport;

    const validUntilForExport = this.isTask3EvaluateOfferInquiry
      ? this.formModel?.validUntil
      : undefined;

    const quotationLinesLabel = this.isTask7ExecuteOptionalService
      ? this.translateService.instant(
          'taskmodule.task.offer.locations_addendum_positions'
        )
      : this.translateService.instant(
          'taskmodule.task.offer.locations_offer_positions'
        );

    this.taskExcelExportService.exportOplExtTask(
      this.entity.entity,
      locations,
      fmIncidentArchObj,
      { validUntil: validUntilForExport },
      'Ticketdetails OPL Extern.xlsx',
      'Ticketdetails OPL Extern',
      quotationLines.length > 0 ? quotationLines : undefined,
      quotationLinesLabel,
      hidePricesForLocations,
      hidePurchasingInformation,
      hideAuxilaryAccountAssignment,
      showLocationsAfterPurchasingInfo,
      columnsForExport,
      quotationLineColumnsForExport,
      false,
      this.isTask11SubmitInvoiceToScanCenter
        ? this.translateService.instant(
            'taskmodule.task.offer.locations_facturation_positions'
          )
        : this.isTask7ExecuteOptionalService
          ? this.translateService.instant(
              'taskmodule.task.offer.locations_offer_positions_order'
            )
          : this.isTask3EvaluateOfferInquiry
            ? this.translateService.instant(
                'taskmodule.task.offer.locations_offer'
              )
            : this.translateService.instant('taskmodule.shared.label__locations'),
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.order_price_location')}:`
        : undefined,
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.order_sum_total')}:`
        : undefined,
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.total_addendum_positions_label')}:`
        : undefined,
      this.isTask7ExecuteOptionalService
        ? `${this.translateService.instant('taskmodule.task.offer.total_addendum_positions_label')}:`
        : undefined
    );

    this.canDownload = true;
  }

  private translateIfKey(key?: string | null): string | undefined {
    return translateIfTooltipKey(
      (translationKey: string) => this.translateService.instant(translationKey),
      key
    );
  }

  private getTaskTooltipKey(base: string): string | null {
    return buildTaskTooltipKey(
      base,
      this.isTask2EvaluateOffersAndCreateSuppliers,
      this.isTask3EvaluateOfferInquiry,
      this.isTask7ExecuteOptionalService,
      this.isTask11SubmitInvoiceToScanCenter
    );
  }
}
